import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { CalendarBlank } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import UpdatedTimeText from '@/common/components/UpdatedTimeText/UpdatedTimeText'
import AppContext from '@/common/context/app.context'

import * as Styles from './styles'

const ParcelDate = ({ date, modified }) => {
  const { info } = useContext(AppContext)
  const { i18n } = useTranslation()

  if (!date || !modified) return null

  return (
    <Styles.Container>
      <CalendarBlank size={24} />
      <Text type="bodyMRegular">
        {new Intl.DateTimeFormat(i18n.language, {
          dateStyle: 'medium',
          timeZone: info?.selectedStore?.timezone,
        }).format(new Date(date))}
      </Text>
      <Text type="bodyMRegular">|</Text>
      <UpdatedTimeText modified={modified} />
    </Styles.Container>
  )
}

export default ParcelDate
